import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#C9A55C] hover:text-[#C9A55C]/80 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1 className="text-4xl font-serif font-bold text-white mb-8">Politique de Confidentialité</h1>

        <div className="space-y-8 text-white/70">
          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">1. Introduction</h2>
            <p>
              HELP ADN, représentée par Jennifer Vanderbergue, s'engage à protéger la vie privée 
              des utilisateurs de son site. Cette politique de confidentialité explique comment 
              nous collectons, utilisons et protégeons vos données personnelles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">2. Responsable du traitement</h2>
            <ul className="space-y-2">
              <li><strong className="text-white">Nom :</strong> Jennifer Vanderbergue</li>
              <li><strong className="text-white">Entreprise :</strong> HELP ADN</li>
              <li><strong className="text-white">Adresse :</strong> Hauts-de-France</li>
              <li><strong className="text-white">Email :</strong> contact@helpadn.fr</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">3. Données collectées</h2>
            <p>Nous collectons les données suivantes via notre formulaire de contact :</p>
            <ul className="mt-4 space-y-2 list-disc list-inside">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
              <li>Type de profil (particulier, entrepreneur, association, entreprise)</li>
              <li>Message / description de votre besoin</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">4. Finalité du traitement</h2>
            <p>Vos données sont collectées pour :</p>
            <ul className="mt-4 space-y-2 list-disc list-inside">
              <li>Répondre à vos demandes de contact</li>
              <li>Établir des devis personnalisés</li>
              <li>Assurer le suivi de nos prestations</li>
              <li>Vous recontacter dans le cadre de nos services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">5. Base légale</h2>
            <p>
              Le traitement de vos données repose sur votre consentement, exprimé lors de 
              l'envoi du formulaire de contact, ainsi que sur l'exécution de mesures précontractuelles 
              prises à votre demande.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">6. Durée de conservation</h2>
            <p>
              Vos données sont conservées pendant une durée de 3 ans à compter de notre dernier 
              contact, conformément aux recommandations de la CNIL.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">7. Destinataires des données</h2>
            <p>
              Vos données personnelles sont strictement confidentielles et ne sont transmises à 
              aucun tiers. Seule Jennifer Vanderbergue, en tant que responsable de HELP ADN, 
              a accès à ces informations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">8. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="mt-4 space-y-2 list-disc list-inside">
              <li><strong className="text-white">Droit d'accès :</strong> obtenir une copie de vos données</li>
              <li><strong className="text-white">Droit de rectification :</strong> corriger vos données</li>
              <li><strong className="text-white">Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong className="text-white">Droit à la limitation :</strong> limiter le traitement de vos données</li>
              <li><strong className="text-white">Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
              <li><strong className="text-white">Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
            <p className="mt-4">
              Pour exercer ces droits, contactez-nous à : 
              <a href="mailto:contact@helpadn.fr" className="text-[#C9A55C] hover:underline ml-1">
                contact@helpadn.fr
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">9. Sécurité</h2>
            <p>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées 
              pour protéger vos données contre tout accès non autorisé, perte ou altération.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">10. Cookies</h2>
            <p>
              Ce site n'utilise pas de cookies de suivi ou de publicité. Seuls des cookies 
              techniques essentiels au fonctionnement du site peuvent être utilisés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">11. Réclamation</h2>
            <p>
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire 
              une réclamation auprès de la CNIL : 
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#C9A55C] hover:underline ml-1">
                www.cnil.fr
              </a>
            </p>
          </section>

          <p className="text-sm text-white/40 pt-8 border-t border-[#C9A55C]/20">
            Dernière mise à jour : Mars 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
